import type { RouteRecordRaw } from 'vue-router'

export const homeRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'landing',
    component: () => import('./pages/LandingPage.vue'),
    meta: { guest: true, layout: 'full' },
  },
  {
    path: '/dashboard',
    name: 'home',
    component: () => import('./pages/HomePage.vue'),
    meta: { requiresAuth: true },
  },
]
